import React from 'react';
import ScrollAnimation from '../components/ScrollAnimation';
import './Terms.css';

const Terms = () => {
  return (
    <div className="terms-page">
      <section className="terms-hero section">
        <div className="container">
          <ScrollAnimation delay={0}>
            <h1 className="page-title">Terms & Conditions</h1>
          </ScrollAnimation>
          <ScrollAnimation delay={200}>
            <p className="page-subtitle">
              Please read these terms and conditions carefully before using CableBiz services
            </p>
          </ScrollAnimation>
        </div>
      </section>

      <section className="terms-content section">
        <div className="container">
          <div className="legal-content">
            <ScrollAnimation delay={0}>
              <div className="legal-section">
                <h2>Introduction</h2>
                <p>
                  The terms "We" / "Us" / "Our" / "Company" individually and collectively refer to <strong>NEELADRI SOFTWARE SOLUTIONS PVT. LTD.</strong> and the terms "You" / "Your" / "Yourself" refer to the users.
                </p>
                <p>
                  This Terms & Conditions document is an electronic record in the form of an electronic contract formed under the Information Technology Act, 2000 and the rules made thereunder and the amended provisions pertaining to electronic documents / records in various statutes as amended by the Information Technology Act, 2000. This Terms & Conditions document does not require any physical, electronic or digital signature.
                </p>
                <p>
                  This Terms & Conditions document is a legally binding document between you and <strong>NEELADRI SOFTWARE SOLUTIONS PVT. LTD.</strong> (both terms defined below). The terms of this document will be effective upon your acceptance of the same.
                </p>
                <p>
                  This document is published and shall be construed in accordance with the provisions of the Information Technology (reasonable security practices and procedures and sensitive personal data of information) rules, 2011 under Information Technology Act, 2000; that require publishing of the Terms & Conditions for collection, use, storage and transfer of sensitive personal data or information.
                </p>
                <p>
                  Please read this Terms & Conditions document carefully. By using our services, you indicate that you understand, agree and consent to this Terms & Conditions. If you do not agree with the terms of this document, please do not use our services.
                </p>
                <p>
                  By providing us your Information or by making use of the facilities provided by the Website, You hereby consent to the collection, storage, processing and transfer of any or all of Your Personal Information and Non-Personal Information by us as specified under this Terms & Conditions. You further agree that such collection, use, storage and transfer of Your Information shall not cause any loss or wrongful gain to you or any other person.
                </p>
              </div>
            </ScrollAnimation>

            <ScrollAnimation delay={100}>
              <div className="legal-section">
                <h2>1. Description of Service</h2>
                <p>
                  CableBiz provides an online billing software solution for cable TV operators and their customers. 
                  Our services include but are not limited to:
                </p>
                <ul>
                  <li>Subscription plan management</li>
                  <li>Customer database management</li>
                  <li>Payment processing and billing</li>
                  <li>Real-time reporting and analytics</li>
                  <li>Mobile applications for operators and customers</li>
                  <li>Customer support and ticketing system</li>
                </ul>
              </div>
            </ScrollAnimation>

            <ScrollAnimation delay={200}>
              <div className="legal-section">
                <h2>2. User Accounts and Registration</h2>
                <p>
                  To access certain features of CableBiz, you must register for an account. You agree to:
                </p>
                <ul>
                  <li>Provide accurate, current, and complete information during registration</li>
                  <li>Maintain and update your account information to keep it accurate</li>
                  <li>Maintain the security of your password and account</li>
                  <li>Accept responsibility for all activities that occur under your account</li>
                  <li>Notify us immediately of any unauthorized use of your account</li>
                </ul>
              </div>
            </ScrollAnimation>

            <ScrollAnimation delay={300}>
              <div className="legal-section">
                <h2>3. Payment Details</h2>
                <p>
                  When you purchase a subscription, you must provide us with complete and accurate payment information. 
                  By submitting payment details you promise that you are entitled to purchase a subscription using those 
                  payment details. If we do not receive payment authorization or any authorization is subsequently cancelled, 
                  we may immediately terminate or suspend your access to your subscription. In suspicious circumstances we 
                  may contact the issuing bank/payment provider and/or law enforcement authorities or other appropriate 
                  third parties. If you are entitled to a refund under these terms and conditions we will credit that refund 
                  to the card or other payment method you used to submit payment, unless it has expired in which case we 
                  will contact you.
                </p>
                <p>
                  CableBiz will use the services of quality third party payment service providers to process your payment. 
                  Payment options are primarily through credit card. CableBiz may offer other payment mechanisms from time to time.
                </p>
              </div>
            </ScrollAnimation>

            <ScrollAnimation delay={400}>
              <div className="legal-section">
                <h2>4. Pricing</h2>
                <p>
                  The subscription price will be made clear to you on our sign-up pages or otherwise during the sign-up 
                  process and may vary from time to time, by region or by country. You agree to pay the fees at the rates 
                  notified to you at the time you purchase your subscription. Subscription to premium services on CableBiz 
                  are generally of monthly frequency. CableBiz however may choose to offer fixed term or fixed payment 
                  frequency offers from time to time. The currency in which your subscription is payable will be specified 
                  during the order process, depending on the service and your country of residence. Eligibility for any 
                  discounts is ascertained at the time you subscribe and cannot be changed during the term of your subscription. 
                  We will always tell you in advance of any increase in the price of your subscription and offer you an 
                  opportunity to cancel it if you do not wish to pay the new price.
                </p>
              </div>
            </ScrollAnimation>

            <ScrollAnimation delay={500}>
              <div className="legal-section">
                <h2>5. Taxes</h2>
                <p>
                  Subscription and access to content services fall under the purview of Service Tax as per the current 
                  indirect taxation policy, Government of India. Taxes are applicable for consumption of content on the 
                  website and other products of CableBiz uniformly for customers based in India and outside the country. 
                  Unless otherwise indicated, prices stated on our website are inclusive of applicable Service Tax, any 
                  applicable value added tax (VAT) or other sales taxes.
                </p>
              </div>
            </ScrollAnimation>

            <ScrollAnimation delay={600}>
              <div className="legal-section">
                <h2>6. User Responsibilities</h2>
                <p>You agree to use CableBiz services only for lawful purposes and in accordance with these Terms. 
                You agree not to:</p>
                <ul>
                  <li>Violate any applicable laws or regulations</li>
                  <li>Infringe upon the rights of others</li>
                  <li>Transmit any harmful, offensive, or inappropriate content</li>
                  <li>Attempt to gain unauthorized access to our systems or other users' accounts</li>
                  <li>Interfere with or disrupt the service or servers</li>
                  <li>Use automated systems to access the service without authorization</li>
                  <li>Reverse engineer, decompile, or disassemble any part of the service</li>
                </ul>
              </div>
            </ScrollAnimation>

            <ScrollAnimation delay={700}>
              <div className="legal-section">
                <h2>7. Intellectual Property Rights</h2>
                <p>
                  All content, features, and functionality of CableBiz, including but not limited to text, graphics, 
                  logos, icons, images, software, and the compilation thereof, are the property of NEELADRI SOFTWARE 
                  SOLUTIONS PVT. LTD. and are protected by Indian and international copyright, trademark, and other 
                  intellectual property laws.
                </p>
                <p>
                  You may not reproduce, distribute, modify, create derivative works of, publicly display, or 
                  commercially exploit any content from CableBiz without our express written permission.
                </p>
              </div>
            </ScrollAnimation>

            <ScrollAnimation delay={800}>
              <div className="legal-section">
                <h2>8. Privacy Policy</h2>
                <p>
                  We take appropriate security measures to protect against unauthorized access to or unauthorized alteration, 
                  disclosure or destruction of data. These include internal reviews of our data collection, storage and 
                  processing practices and security measures, including appropriate encryption and physical security measures 
                  to guard against unauthorized access to systems where we store personal data.
                </p>
                <p>
                  All information gathered on our Website is securely stored within our controlled database. The database is 
                  stored on servers secured behind a firewall; access to the servers is password-protected and is strictly 
                  limited. However, as effective as our security measures are, no security system is impenetrable. We 
                  cannot guarantee the security of our database, nor can we guarantee that information you supply will not 
                  be intercepted while being transmitted to us over the Internet. And, of course, any information you 
                  include in a posting to the discussion areas is available to anyone with Internet access.
                </p>
                <p>
                  However the internet is an ever evolving medium. We may change our Privacy Policy from time to time to 
                  incorporate necessary future changes. Of course, our use of any information we gather will always be 
                  consistent with the policy under which the information was collected, regardless of what the new policy 
                  may be.
                </p>
                <p>
                  Your use of CableBiz is also governed by our Privacy Policy. We take data security seriously and implement 
                  industry-standard measures to protect your information. However, you acknowledge that:
                </p>
                <ul>
                  <li>No method of transmission over the Internet is 100% secure</li>
                  <li>You are responsible for maintaining the confidentiality of your account credentials</li>
                  <li>We may collect and use your data as described in our Privacy Policy</li>
                </ul>
              </div>
            </ScrollAnimation>

            <ScrollAnimation delay={900}>
              <div className="legal-section">
                <h2>9. Service Availability and Modifications</h2>
                <p>
                  We strive to provide continuous and reliable service, but we do not guarantee that the service will 
                  be available at all times. We may:
                </p>
                <ul>
                  <li>Perform scheduled maintenance that may temporarily interrupt service</li>
                  <li>Modify, suspend, or discontinue any part of the service at any time</li>
                  <li>Update features and functionality to improve the service</li>
                </ul>
                <p>
                  We will make reasonable efforts to notify users of significant service interruptions or changes.
                </p>
              </div>
            </ScrollAnimation>

            <ScrollAnimation delay={1000}>
              <div className="legal-section">
                <h2>10. Limitation of Liability</h2>
                <p>
                  To the maximum extent permitted by law, NEELADRI SOFTWARE SOLUTIONS PVT. LTD. shall not be liable 
                  for any indirect, incidental, special, consequential, or punitive damages, or any loss of profits or 
                  revenues, whether incurred directly or indirectly, or any loss of data, use, goodwill, or other 
                  intangible losses resulting from your use of CableBiz.
                </p>
                <p>
                  Our total liability for any claims arising from or related to the service shall not exceed the amount 
                  you paid us in the twelve (12) months preceding the claim.
                </p>
              </div>
            </ScrollAnimation>

            <ScrollAnimation delay={1100}>
              <div className="legal-section">
                <h2>11. Indemnification</h2>
                <p>
                  You agree to indemnify, defend, and hold harmless NEELADRI SOFTWARE SOLUTIONS PVT. LTD., its officers, 
                  directors, employees, and agents from and against any claims, liabilities, damages, losses, and expenses, 
                  including reasonable attorney's fees, arising out of or in any way connected with your use of CableBiz 
                  or violation of these Terms.
                </p>
              </div>
            </ScrollAnimation>

            <ScrollAnimation delay={1200}>
              <div className="legal-section">
                <h2>12. Termination</h2>
                <p>
                  We may terminate or suspend your account and access to the service immediately, without prior notice, 
                  for any reason, including if you breach these Terms. Upon termination:
                </p>
                <ul>
                  <li>Your right to use the service will immediately cease</li>
                  <li>You must stop all use of the service</li>
                  <li>We may delete your account and data, subject to our data retention policies</li>
                </ul>
                <p>
                  You may terminate your account at any time by contacting our support team. Termination does not 
                  relieve you of any obligations to pay fees accrued prior to termination.
                </p>
              </div>
            </ScrollAnimation>

            <ScrollAnimation delay={1300}>
              <div className="legal-section">
                <h2>13. Governing Law and Dispute Resolution</h2>
                <p>
                  These Terms shall be governed by and construed in accordance with the laws of India, without regard 
                  to its conflict of law provisions. Any disputes arising from these Terms or your use of CableBiz 
                  shall be subject to the exclusive jurisdiction of the courts in Bhubaneswar, Odisha, India.
                </p>
              </div>
            </ScrollAnimation>

            <ScrollAnimation delay={1400}>
              <div className="legal-section">
                <h2>14. Changes to Terms</h2>
                <p>
                  We reserve the right to modify these Terms at any time. We will notify users of any material changes 
                  by posting the updated Terms on our website and updating the "Last Updated" date. Your continued use 
                  of CableBiz after such modifications constitutes your acceptance of the updated Terms.
                </p>
              </div>
            </ScrollAnimation>

            <ScrollAnimation delay={1500}>
              <div className="legal-section">
                <h2>15. Grievance Redressal</h2>
                <p>
                  <strong>Redressal Mechanism:</strong> Any complaints, abuse or concerns with regards to content and 
                  or comment or breach of these terms shall be immediately informed to the designated Grievance Officer 
                  as mentioned below via in writing or through email signed with the electronic signature.
                </p>
                <div className="contact-info">
                  <p><strong>Grievance Officer:</strong> Mr. Biswajit Panda</p>
                  <p><strong>Email:</strong> bpanda@nldsoft.com</p>
                  <p><strong>Company:</strong> NEELADRI SOFTWARE SOLUTIONS PVT. LTD.</p>
                  <p><strong>Phone:</strong> +91 7750963445</p>
                </div>
              </div>
            </ScrollAnimation>

            <ScrollAnimation delay={1600}>
              <div className="legal-section">
                <h2>16. Contact Information</h2>
                <p>
                  If you have any questions about these Terms & Conditions, please contact us:
                </p>
                <div className="contact-info">
                  <p><strong>Email:</strong> info@nldsoft.com</p>
                  <p><strong>Support:</strong> support@nldsoft.com</p>
                  <p><strong>Phone:</strong> +91 7750963445, +91 9938684996</p>
                  <p><strong>Address:</strong> Plot No: 52, Bapujinagar, Bhubaneswar, Odisha, India - 751009</p>
                </div>
              </div>
            </ScrollAnimation>

            <ScrollAnimation delay={1400}>
              <div className="legal-section">
                <p className="last-updated">
                  <strong>Last Updated:</strong> {new Date().toLocaleDateString('en-IN', { year: 'numeric', month: 'long', day: 'numeric' })}
                </p>
              </div>
            </ScrollAnimation>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Terms;

